import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, SharedModule],
})
export class TermsOfServiceComponent {
  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
